import { useTranslate } from '@repo/shared/hooks'
import { z } from 'zod'

export const useReferralCodeSchema = () => {
  const { t } = useTranslate()

  const schema = z.object({
    referralCode: z
      .string({
        message: t('order_referral_code_required'),
      })
      .min(1, {
        message: t('order_referral_code_required'),
      })
      .max(50, {
        message: t('order_referral_code_too_long'),
      }),
  })

  return { schema }
}
